import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { toPascalCase } from '@cli-utils/text.js'
import { renderTabsTriggerTabsLayoutTemplate } from '@next-adapter/templates/renderers/generators/form/form-shared/render-tabs-trigger.js'

export function renderTabsTrigger(
  tab: NonNullable<SchemaField['tabs']>[number],
  indent: string,
  options: { className?: string } = {}
): string {
  const iconName = tab.icon?.trim() ? toPascalCase(tab.icon.trim()) : null
  const className = options.className ? ` className="${options.className}"` : ''
  if (!iconName)
    return `${indent}<TabsTrigger value="${tab.name}"${className}>${tab.label}</TabsTrigger>`

  return renderTabsTriggerTabsLayoutTemplate({
    indent: indent,
    tabName: tab.name,
    className: className,
    iconName: iconName,
    tabLabel: tab.label
  })
}
